import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';

@Component({
    selector: 'marv-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss']
})
export class MarvTabComponent  implements OnInit {

    @Input({alias : 'tabId', required : true}) id: string;   

    @ViewChild('content') content!: TemplateRef<string>;

    constructor() { }

    ngOnInit() {}

}
